'use client'

import React from 'react'
import ActivityProducts from '@dustin-web/product-components/src/activity-products'

//     var preserveProductOrder = MacroParameterExtractor.GetBoolean("preserveproductorder", Model);
//     int containerWidth = MacroParameterExtractor.GetInt("containerWidth", Model) ?? 8;
type Props = {
  activityid?: string
  preserveproductorder: boolean //type? needed?
  containerWidth: number //type? needed?
}

export const MultipleProductBoxesBasedonActivityid = ({ activityid }: Props) => {
  const parsedActivityId = activityid && parseInt(activityid)
  return parsedActivityId ? (
    <ActivityProducts activityId={parsedActivityId} digitalDataOrigin="contentMacro" />
  ) : null
  //Kampanj
}

export default MultipleProductBoxesBasedonActivityid
